import styled from 'styled-components'

export const VideoDescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow: auto;
  padding: 30px;
  flex-grow: 1;
`

export const VideoTitle = styled.h2`
  color: ${props => (props.darkMode ? '#f1f5f9' : '#0f0f0f')};
`

export const StaticAndDynamicInfoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 98%;
`

export const StaticContentContainer = styled.div`
  display: flex;
  align-items: center;
`

export const DynamicContainer = styled(StaticContentContainer)``

export const LikeBtn = styled.button`
  display: flex;
  align-items: center;
  margin-left: 16px;
  border-width: 0;
  background-color: transparent;
  cursor: pointer;
  outline: none;
  font-size: 14px;
  color: ${props => (props.liked ? '#2563eb' : '#64748b')};
`

export const DisLikeBtn = styled(LikeBtn)`
  color: ${props => (props.disliked ? '#2563eb' : '#64748b')};
`

export const LikeContent = styled.div`
  margin-left: 5px;
`

export const AddPlaylistBtn = styled(LikeBtn)`
  color: ${props => (props.isSaved ? '#2563eb' : '#64748b')};
`

export const HorizontalLine = styled.hr`
  border: 0.6px solid #64748b;
  width: 100%;
  margin: 40px 0 40px 0;
`

export const ChannelAndVideoDescriptionContainer = styled.div`
  display: flex;
  align-items: flex-start;
`

export const ChannelImg = styled.img`
  width: 60px;
`

export const AboutChannelAndDescriptionContainer = styled.div`
  margin-left: 16px;
`

export const ChannelName = styled.h4`
  margin-top: 0;
  color: ${props => (props.darkMode ? '#f1f5f9' : '#0f0f0f')};
`

export const SubscriberCount = styled.p`
  color: #64748b;
`

export const VideoDescription = styled(SubscriberCount)``

export const SaveContent = styled(LikeContent)``
